module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp2_8023.2f817e06.png";